// SPDX-License-Identifier: AGPL-3.0-or-later
import { createContext, useContext } from "react";
import type { Store } from "./store.js";

export interface AppContextValue {
  store: Store;
  today: string;
  /** Speaks a short message through the page's polite live region. */
  announce: (message: string) => void;
  lock: () => void;
  signOut: () => void;
}

export const AppContext = createContext<AppContextValue | null>(null);

export function useApp(): AppContextValue {
  const value = useContext(AppContext);
  if (!value) throw new Error("useApp outside AppContext");
  return value;
}
